export default __webpack_public_path__ + "static/media/award5.fc8cc879.png";